import { render, staticRenderFns } from "./MyService.vue?vue&type=template&id=52769586&scoped=true"
import script from "./MyService.vue?vue&type=script&lang=js"
export * from "./MyService.vue?vue&type=script&lang=js"
import style0 from "./MyService.vue?vue&type=style&index=0&id=52769586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52769586",
  null
  
)

export default component.exports